<template>
  <div id="app" class="app">
    <component :is="layoutComponent"></component>
    <app-loader></app-loader>
    <app-modals></app-modals>
    <app-privacy-statement></app-privacy-statement>
  </div>
</template>

<script src="./app.js"></script>
<style src="./app.scss" lang="scss"></style>
